/**
 * Поверхностное сравнение двух значений.
 * Подходит для примитивов, плоских массивов и plain-объектов.
 * Не поддерживает глубокие структуры, классы, Map/Set, Date/RegExp (сравнение только по ссылке).
 *
 * TODO: при необходимости расширить поддержку типов (Date по значению, Map/Set по содержимому)
 *       или добавить перегрузки/отдельные сравниватели для специфичных структур.
 */
export function shallowEqual(a: unknown, b: unknown): boolean {
  if (Object.is(a, b)) return true;
  if (typeof a !== 'object' || a === null || typeof b !== 'object' || b === null) return false;
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (!Object.is(a[i], b[i])) return false;
    }
    return true;
  }
  const aObj = a as Record<string, unknown>;
  const bObj = b as Record<string, unknown>;
  const aKeys = Object.keys(aObj);
  const bKeys = Object.keys(bObj);
  if (aKeys.length !== bKeys.length) return false;
  for (const k of aKeys) {
    if (!Object.prototype.hasOwnProperty.call(bObj, k)) return false;
    if (!Object.is(aObj[k], bObj[k])) return false;
  }
  return true;
}
